import { isEqual, uniqWith } from 'es-toolkit';

import type { BrowseDimensionKey } from '@/utils/browsePath/itemFacetBrowsePath';

import { CategoryLandingLink } from '@/types/CategoryLink';
import { ItemFacet, ItemFacets } from '@/types/ItemFacets';

/**
 * A facet refining a category, paired with the browse dimension it came from. The two travel
 * together because the facet objects carry no marker distinguishing a creator from a material,
 * and the browse path cannot be built without knowing which it is.
 */
export type DiscoverLinkRefinement = {
    dimension: BrowseDimensionKey;
    item: ItemFacet;
};

export const generateDiscoverLinks = (
    facets: ItemFacets,
    createCategoryLandingLink: (mainItem: ItemFacet, refinement?: DiscoverLinkRefinement) => CategoryLandingLink
): CategoryLandingLink[] => {
    const discoverItems: CategoryLandingLink[] = [];
    let shouldCreateMat = true;
    let shouldCreateCreator = true;
    if (facets && facets.categories && facets.categories.length > 0 && facets.creators) {
        facets.creators.some((creator, index) => {
            discoverItems.push(
                createCategoryLandingLink(facets.categories[0], { dimension: 'creator', item: creator })
            );
            return index === 1;
        });

        shouldCreateCreator = false;
    }

    if (facets && facets.creators && facets.creators.length > 0 && shouldCreateCreator) {
        discoverItems.push(createCategoryLandingLink(facets.creators[0]));
    }

    if (facets && facets.materialsTechniques && facets.categories && facets.categories.length > 0) {
        facets.materialsTechniques.some((materialsTechniques, index) => {
            discoverItems.push(
                createCategoryLandingLink(facets.categories[0], { dimension: 'material', item: materialsTechniques })
            );
            return index === 1;
        });

        shouldCreateMat = false;
    }

    if (facets && facets.materialsTechniques && facets.materialsTechniques.length > 0 && shouldCreateMat) {
        discoverItems.push(createCategoryLandingLink(facets.materialsTechniques[0]));
    }
    if (facets && facets.categories && facets.categories.length > 0) {
        discoverItems.push(createCategoryLandingLink(facets.categories[0]));
    }
    if (facets && facets.stylePeriods && facets.stylePeriods.length > 0) {
        discoverItems.push(createCategoryLandingLink(facets.stylePeriods[0]));
    }
    if (facets && facets.origins && facets.origins.length > 0) {
        discoverItems.push(createCategoryLandingLink(facets.origins[0]));
    }

    return uniqWith(discoverItems, isEqual);
};
